export default __webpack_public_path__ + "static/media/480_dummy2016-haushalthilfe01-de.d0bb0e15.png";